<template>
  <div class="StockAntsOverview">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="cover-page-container">
      <div class="background-cover"></div>
    </div>
    <el-row>
      <el-col :xs="0" :sm="1" :md="1" :lg="1" :xl="1">&nbsp;</el-col>
      <el-col :xs="24" :sm="22" :md="22" :lg="22" :xl="22">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-card class="box-card profile-card">
              <div class="profile-pic-section">
                <img
                  src="../assets/images/stockantsoverview/SA Cover page logo.svg"
                  alt=""
                />
              </div>
              <el-row>
                <el-col :xs="0" :sm="24" :md="4" :lg="4" :xl="4">&nbsp;</el-col>
                <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                  <section
                    class="text-section flex-space-between"
                    style="align-items: start;"
                  >
                    <div class="text" id="text">
                      <p
                        style="
                            font-weight: 600;
                            font-size: 20px;
                            margin-top: 5px;
                            margin-bottom: 5px;
                          "
                      >
                        StockAnts
                      </p>
                      <p
                        style="
                            margin-top: 5px;
                            margin-bottom: 5px;
                            font-size: 13px;
                            font-weight: 500;
                          "
                      >
                        Benefits of StockAnts Premium Plan
                      </p>
                      <div style="display: flex; padding: 0px">
                        <p
                          style="
                              margin-top: 8px;
                              margin-bottom: 8px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                        >
                          <i
                            class="el-icon-success"
                            style="color: #2488FF; margin-right: 10px"
                          ></i>
                          <span
                            style="
                                font-size: 12px;
                                font-weight: 600;
                                color: #000000;
                                justify-content: center;
                              "
                            >SEBI Analyst Research at one click
                            <!-- <span
                              style="text-decoration: none; color: rgb(94, 164, 248)"
                              >+More</span
                            > -->
                          </span>
                        </p>
                      </div>

                      <div style="display: flex; padding: 0px; margin: 0px">
                        <p
                          style="
                              margin-top: 5px;
                              margin-bottom: 5px;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            "
                        >
                          <i
                            class="el-icon-success"
                            style="color: #2488FF; margin-right: 10px"
                          ></i>
                          <span
                            style="
                                font-size: 12px;
                                font-weight: 600;
                                color: #000000;
                                justify-content: center;
                              "
                            >Track Recommendations with market prices.</span
                          >
                        </p>
                      </div>

                      <div style="display: flex; padding: 0px; margin: 0px">
                        <p
                          style="
        margin-top: 5px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      "
                        >
                          <i
                            class="el-icon-success"
                            style="color: #2488FF; margin-right: 10px"
                          ></i>
                          <span
                            style="
          font-size: 12px;
          font-weight: 600;
          color: #000000;
          justify-content: center;
        "
                          >
                            Trade with StockAnts-connected brokers.
                            <a
                              href="javascript:void(0);"
                              @click="showDialog = true"
                              style="
            font-size: 12px;
            font-weight: 600;
            color: #007BFF;
            margin-left: 5px;
            text-decoration: none;
          "
                            >
                              &More
                            </a>
                          </span>
                        </p>

                        <!-- Dialog with responsive width -->
                        <el-dialog
                          :visible.sync="showDialog"
                          @close="handleClose"
                          custom-class="custom-dialog"
                        >
                          <!-- Centered Title -->
                          <template #title>
                            <h2 class="dialog-title">StockAnts Premium</h2>
                          </template>

                          <!-- Section 1: Discover -->
                          <div class="section">
                            <div class="section-header">
                              <i
                                class="el-icon-search icon"
                                style="color: #2D2E8D;"
                              ></i>
                              <h3 class="section-title">Discover</h3>
                            </div>

                            <ul class="section-content">
                              <li>
                                Access a bundle of SEBI Expert
                                Recommendations/strategies at one click.
                              </li>
                              <li>
                                Daily 15+ recommendations/strategies for smarter
                                investing.
                              </li>
                            </ul>
                          </div>

                          <!-- Section 2: Benefits -->
                          <div class="section">
                            <div class="section-header">
                              <i
                                class="el-icon-check icon"
                                style="color: #2D2E8D;"
                              ></i>
                              <h3 class="section-title">Validate</h3>
                            </div>

                            <ul class="section-content">
                              <li>
                                Track SEBI Expert recommendations with market
                                prices.
                              </li>
                              <li>
                                30 second validation with advanced tools like
                                aggregated market sentiment,charts, technical
                                analysis, and indicators.
                              </li>
                            </ul>
                          </div>

                          <!-- Section 3: Support -->
                          <div class="section">
                            <div class="section-header">
                              <img
                                src="../assets/images/two-arrows.png"
                                alt="Support Icon"
                                class="icon"
                                style="filter: brightness(0) invert(0); width: 15px; height: 15px;"
                              />

                              <h3 class="section-title">Trade</h3>
                            </div>
                            <ul class="section-content">
                              <li>
                                Watchlist handpicked recommendations for status
                                updates and instant notifications.
                              </li>
                              <li>
                                Seamlessly place trade with StockAnts-connected
                                brokers.
                              </li>
                            </ul>
                          </div>
                        </el-dialog>
                      </div>
                    </div>

                    <!-- Youtube logo button -->
                    <div class="u-tube-btn">
                      <img
                        src="../assets/images/Youtube Icon.png"
                        class="social-icon"
                        style="margin-left: 10px;"
                        @click="videoDialog = true"
                      />
                    </div>
                  </section>
                </el-col>

                <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                  <div class="text flex">
                    <!-- Subscribe button -->
                    <el-button
                      class="btn-secondary-theme-filled subscribe-btn"
                      v-on:click="goToLink('/pricing')"
                      type="primary"
                      >Subscribe</el-button
                    >
                    <!-- Youtube logo button -->
                    <img
                      src="../assets/images/Youtube Icon.png"
                      class="youtube-btn social-icon"
                      style="margin-left: 10px;"
                      @click="videoDialog = true"
                    />
                  </div>
                </el-col>
              </el-row>

              <!-- overall_rating -->
            </el-card>
          </el-col>
        </el-row>

        <div class="about-section">
          <el-row>
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <el-card class="box-card about-us-card" style="height: 335px">
                <div
                  class="flex-space-between font-09rem font-weight-600; height: 385px"
                >
                  <div class="flex font-09rem font-weight-600 bottom-margin-10">
                    Top Potential Recommendation
                  </div>
                </div>
                <div
                  class="top-pick-section"
                  :class="{ blur: showLockSection }"
                >
                  <div style="">
                    <div
                      class="font-09rem font-weight-500"
                      style="color: rgb(44, 132, 247); cursor: pointer;"
                      @click="goToLink('/experts-past-recommendations')"
                    >
                      <div class="card-container">
                        <div class="scrollable-content">
                          <table class="stock-table">
                            <thead>
                              <tr>
                                <th
                                  style="padding-bottom: 5px;"
                                  class="text-left"
                                >
                                  Recommended<br />
                                  Stocks by SEBI RA
                                </th>
                                <th style="padding-bottom: 5px;">
                                  Remaining Target
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="stock in stocks" :key="stock.id">
                                <td class="stock-data" style="text-align:left">
                                  {{ stock.stocks_name || stock.stock_name }}
                                </td>
                                <td class="potential">
                                  {{
                                    stock.remaining_potential !== null
                                      ? isFloat(stock.remaining_potential) + "%"
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <LockSection :showLockSection="showLockSection" />
                    </div>

                    <!-- Subscribe button -->
                    <div
                      class="about-subscribe-btn"
                      style="margin-top: 20px; display: flex; justify-content: center"
                    >
                      <el-button
                        id="subscribe-button"
                        type="primary"
                        v-on:click="goToLink('/pricing')"
                        style="
                                width: 230px;
                                height: 45px;
                                background-color: #2d2d8d;
                                border-radius: 12px;
                              "
                        ><span style="color: white; font-size: 14"
                          >Subscribe</span
                        ></el-button
                      >
                    </div>
                  </div>
                </div>
              </el-card>

              <el-card class="box-card about-us-card">
                <div class="flex font-09rem font-weight-600">About Us</div>
                <div style="margin-top: 15px;">
                  <div class="font-08rem font-weight-500 secondary-theme-color">
                    <span
                      style="
                              color: rgb(16, 16, 16);
                              line-height: 1.7;
                              font-size: 0.8rem;
                              font-weight: 500;
                            "
                      >StockAnts is a marketplace for price estimates. We
                      aggregate SEBI registered experts’ research with realtime
                      tracking to help retail users to decide on investment &
                      trade with your Broker.</span
                    >
                  </div>
                  <p
                    style="color: rgb(182, 182, 182); font-weight: 500; font-size: 0.8rem"
                  >
                    Social Media Accounts
                  </p>
                  <div class="social-icon-container">
                    <a
                      href="https://www.facebook.com/StockAnts/?view_public_for=186471548792050"
                      target="_blank"
                      ><img
                        src="../assets/images/facebook.png"
                        alt=""
                        class="social-icon"
                        style="height: 22px; width: 22px"
                    /></a>

                    <a
                      href="https://www.linkedin.com/company/31128790/admin/feed/posts/"
                      target="_blank"
                      ><img
                        src="../assets/images/linkedin.png"
                        class="social-icon"
                        style="
                                height: 22px;
                                width: 22px;
                                margin-left: 10px;
                                margin-right: 10px;
                              "
                    /></a>
                    <a href="mailto:admin@stockants.com" target="_blank"
                      ><img
                        src="../assets/images/gmail.svg"
                        class="social-icon"
                        style="
                                height: 22px;
                                width: 22px;
                                margin-right: 10px;
                              "
                    /></a>
                    <a
                      href="https://www.youtube.com/@stockants3475"
                      target="_blank"
                    >
                      <img
                        src="../assets/images/Youtube Icon.png"
                        class="social-icon"
                        style="
                                height: 22px;
                                width: 22px;
                                margin-right: 10px;
                              "
                    /></a>

                    <a
                      href="https://www.whatsapp.com/channel/0029Vas4r0FGehEP7GOA6W0R"
                      target="_blank"
                    >
                      <img
                        src="../assets/images/whatsapp.png"
                        class="social-icon"
                        style="
                                height: 22px;
                                width: 22px;
                                margin-right: 10px;
                              "
                    /></a>

                    <a href="https://t.me/stockants" target="_blank">
                      <img
                        src="../assets/images/telegram.svg"
                        class="social-icon"
                        style="
                                height: 22px;
                                  width: 22px;
                                margin-right: 20px;
                              "
                    /></a>
                  </div>
                </div>
              </el-card>

              <el-card class="box-card about-us-card">
                <div class="flex-space-between font-09rem font-weight-600">
                  <div class="flex">Reviews</div>

                  <el-button
                    class="btn-theme-borderd"
                    size="mini"
                    v-if="(user_id = userProfile.id)"
                    @click="openReviewDialog()"
                    >WRITE REVIEW</el-button
                  >
                </div>

                <div class="top-margin-10">
                  <div
                    class="bottom-margin-10"
                    v-for="(review, review_index) in review_list"
                    :key="review_index"
                    :style="[
                      review_index < review_list.length - 1
                        ? { borderBottom: '1px solid #f1f1f1' }
                        : '',
                    ]"
                  >
                    <div style="display: flex; padding: 5px">
                      <!-- <div class="profile-pic"> -->
                      <img
                        :src="serverHostName + review.profile_pic"
                        v-if="review.profile_pic"
                        class="profile-pic"
                        style="width: 45px; height: 45px"
                      />

                      <img
                        src="../assets/images/navBar/avatar.jpg"
                        v-else
                        class="profile-pic"
                        style="width: 45px; height: 45px"
                      />
                      <!-- </div> -->

                      <div>
                        <div
                          class="font-08rem capitalize font-weight-600 left-margin-15 line-height-1-5"
                        >
                          {{ review.name }}
                        </div>

                        <div
                          class="font-06rem font-weight-500 left-margin-15 line-height-1-5"
                          style="color: #979797"
                        >
                          {{ review.designation }}
                        </div>

                        <el-rate
                          class="left-margin-15"
                          :allow-half="true"
                          v-model="review.rating"
                          disabled
                        ></el-rate>
                      </div>
                    </div>

                    <div style="padding: 0px">
                      <div
                        class="font-08rem font-weight-600 secondary-theme-color"
                      >
                        "{{ review.review_title }}"
                      </div>

                      <div class="font-07rem">
                        {{ review.review }}
                      </div>

                      <div
                        class="font-07rem top-margin-5"
                        style="color: #a7a7a7"
                      >
                        <span><i class="el-icon-time"></i></span>&nbsp;&nbsp;{{
                          moment(review.date).format("DD MMM YYYY HH:mm a")
                        }}
                      </div>
                    </div>

                    <div
                      style="padding: 5px 10px"
                      v-for="(user, user_index) in review.replied_users"
                      :key="user_index"
                      :style="[
                        user_index < review.replied_users.length
                          ? { borderTop: '1px solid #f1f1f1' }
                          : '',
                      ]"
                    >
                      <div
                        class="font-08rem capitalize font-weight-500 line-height-1-5"
                      >
                        {{ user.created_by.first_name }}
                        {{ user.created_by.last_name }}
                      </div>

                      <div class="font-07rem">
                        {{ user.comment }}
                      </div>
                    </div>
                  </div>

                  <div
                    class="font-08rem font-weight-500 top-margin-10 primary-theme-color text-center top-margin-20 bottom-margin-20"
                    v-if="!review_list.length"
                  >
                    No data available
                  </div>

                  <el-pagination
                    class="label-xs-bold text-center top-margin-5"
                    small
                    v-if="total_review_pages > 1 && review_list.length"
                    :current-page.sync="review_current_page_no"
                    @current-change="handleReivewPageCurrentPageChange"
                    :page-size="review_per_page"
                    layout="prev, pager, next"
                    :total="total_reviews"
                  >
                  </el-pagination>
                </div>
              </el-card>
            </el-col>

            <!-- portfolio section -->
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <el-card class="box-card about-us-card fixed-height">
                <div class="flex-space-between font-09rem font-weight-600;">
                  <div class="flex font-09rem font-weight-600">
                    Stockants Premium Overview
                  </div>
                </div>

                <div class="btns">
                  <button
                    type="button"
                    :class="{ 'active-button': activeSegment === 'equity' }"
                    class="el-button btn-theme-borderd el-button--default el-button--mini custm-button"
                    @click="changeActiveSegment('equity')"
                  >
                    <span style="font-weight: 600">Equity</span>
                  </button>
                  <!-- <button
      type="button"
      :class="{ 'active-button': activeSegment === 'options' }"
      class="el-button btn-theme-borderd el-button--default el-button--mini custm-button"
      @click="changeActiveSegment('options')"
    >
      <span style="font-weight: 600">Options</span>
    </button> -->
                </div>

                <!-- divider line  -->
                <div
                  class="line"
                  style="border-bottom: #cfcfcf 1px solid"
                ></div>

                <div class="flex-end top-margin-10 bottom-margin-10">
                  <div
                    class="period-btn-mini"
                    @click="selectPeriod('1M')"
                    :class="[
                      active_period == '1M' ? 'active-period-btn-mini' : '',
                    ]"
                  >
                    1M
                  </div>

                  <div
                    class="period-btn-mini"
                    @click="selectPeriod('3M')"
                    :class="[
                      active_period == '3M' ? 'active-period-btn-mini' : '',
                    ]"
                  >
                    3M
                  </div>
                  <div
                    class="period-btn-mini"
                    @click="selectPeriod('6M')"
                    :class="[
                      active_period == '6M' ? 'active-period-btn-mini' : '',
                    ]"
                  >
                    6M
                  </div>
                  <div
                    class="period-btn-mini"
                    @click="selectPeriod('1Y')"
                    :class="[
                      active_period == '1Y' ? 'active-period-btn-mini' : '',
                    ]"
                  >
                    1Y
                  </div>
                </div>

                <!-- Equity section -->
                <div v-if="activeSegment == 'equity'" class="equity">
                  <div
                    class="flex-start top-margin-10 bottom-margin-10;padding:0px;"
                  >
                    <div
                      class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-8 el-col-lg-8 el-col-xl-8"
                      style="width: 600px"
                    >
                      <div
                        class="el-card markets-profile box-card is-always-shadow"
                        style="border-radius: 10px; margin-top: 5px; margin-bottom: 20px"
                      >
                        <div class="el-card__body">
                          <div class="stock-details-section">
                            <div class="bottom-margin-10">
                              <div class="flex-space-between">
                                <div
                                  class="input-label-gray font-weight-600; font-size:14px"
                                >
                                  Total Recommendation
                                </div>
                                <div
                                  class="input-label-xs-bold-black font-07rem font-weight-600 cursor-pointer"
                                >
                                  {{ performanceData.TotalRecommendation }}
                                </div>
                              </div>
                            </div>

                            <div class="flex relative top-margin-25">
                              <div
                                style="width: 100%; margin: 5px 5px; height: 15px; line-height: 15px; border-radius: 50px;"
                                :style="{
                                  background: `linear-gradient(to right, #079e3e ${getAdvancesPercentage()}%, #d60918 ${100 -
                                    getAdvancesPercentage()}%)`,
                                }"
                              >
                                <div class="flex-space-between">
                                  <div
                                    v-if="getAdvancesPercentage()"
                                    style="color: #fff; font-size: 0.6rem; font-weight: bold; margin-left: 8px;"
                                  >
                                    {{ getAdvancesPercentage() + "%" }}
                                  </div>

                                  <div
                                    style="color: #fff; font-size: 0.6rem; font-weight: bold; margin-right: 8px;"
                                    v-if="getAdvancesPercentage() != 100"
                                  >
                                    {{ 100 - getAdvancesPercentage() + "%" }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="flex relative top-margin-25">
                              <span
                                class="input-label-xs-bold-black absolute"
                                style="font-size: 0.9rem; top: -12px; left: 0px"
                              >
                                {{ performanceData.Advances }} Advances
                              </span>
                              <span
                                class="input-label-xs-bold-black absolute"
                                style="font-size: 0.9rem; top: -12px; right: 0px"
                              >
                                {{ performanceData.Declines }} Declines
                              </span>
                            </div>
                          </div>

                          <div class="bottom-margin-10">
                            <div class="flex-space-between top-margin-20">
                              <div
                                class="input-label-gray font-weight-600;font-size:14px"
                              >
                                Live Recommendation
                              </div>
                              <div
                                class="input-label-xs-bold-black font-07rem font-weight-600 cursor-pointer"
                              >
                                {{ performanceData.LiveRecommendation }}
                              </div>
                            </div>
                          </div>

                          <div class="bottom-margin-10 top-margin-10">
                            <div class="flex-space-between">
                              <div
                                class="input-label-gray font-weight-600;font-size:14px"
                              >
                                Latest Recommendation
                              </div>
                              <div
                                class="input-label-xs-bold-black font-07rem font-weight-600 cursor-pointer"
                              >
                                {{ performanceData.LatestRecommendation }}
                              </div>
                            </div>
                          </div>
                          <!---->
                        </div>

                        <div class="el-loading-mask" style="display: none">
                          <div class="el-loading-spinner">
                            <svg viewBox="25 25 50 50" class="circular">
                              <circle
                                cx="50"
                                cy="50"
                                r="20"
                                fill="none"
                                class="path"
                              ></circle>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-row>
                    <!-- <el-col
                      style="width: 180px; margin-right:10px"
                      class="bottom-margin-10"
                    >
                      <div
                        class="performance-count cursor-pointer"
                        @click="setActivePerformanceLink('ROI')"
                        :style="[
                          active_performance == 'ROI'
                            ? { background: '#E9F3FF' }
                            : { background: '#f8f9fa' },
                        ]"
                      >
                        <div class="flex">
                          <img
                            src="../assets/images/stockantsoverview/ROI Icon.svg"
                            width="18"
                            height="22"
                          />

                          <span style="margin-left: 5px; color: #2488ff"
                            >ROI</span
                          >
                        </div>

                        <div
                          style="color: #079e3e; font-weight: 500; font-size: 15px"
                        >
                          {{
                            expertDetails.absoluteRoi
                              ? isFloat(expertDetails.absoluteRoi) + "%"
                              : "NA"
                          }}
                        </div>
                      </div>
                    </el-col> -->

                    <el-col style="width: 180px" class="bottom-margin-10">
                      <!-- <div
                        class="performance-count cursor-pointer"
                        @click="setActivePerformanceLink('SUCCESS_RATE')"
                        :style="[
                          active_performance == 'SUCCESS_RATE'
                            ? { background: '#E9F3FF' }
                            : { background: '#f8f9fa' },
                        ]"
                      >
                        <div class="flex">
                          <img
                            src="../assets/images/stockantsoverview/Success rate Icon.svg"
                            width="18"
                            style="color: #757575"
                          />

                          <span style="margin-left: 5px; color: #757575"
                            >Success</span
                          >
                        </div>

                        <div
                          style="color: #757575; font-weight: 500; font-size: 15px"
                        >
                          {{
                            expertDetails.successRate
                              ? isFloat(expertDetails.successRate) + "%"
                              : "NA"
                          }}
                        </div>
                      </div> -->
                    </el-col>
                  </el-row>

                  <div class="flex top-margin-25">
                    <div class="flex" style="margin-left: 20px">
                      <div
                        class="sub-menu-bar-link cursor-pointer"
                        @click="setActiveSubMenuLink('STOCKS')"
                        :class="{
                          'active-sub-menu-link':
                            active_sub_menu_link == 'STOCKS',
                        }"
                      >
                        Stocks
                      </div>

                      <div
                        class="sub-menu-bar-link cursor-pointer"
                        @click="setActiveSubMenuLink('SECTOR')"
                        :class="{
                          'active-sub-menu-link':
                            active_sub_menu_link == 'SECTOR',
                        }"
                      >
                        Sector
                      </div>
                    </div>

                    <div
                      class="font-08rem font-weight-600 secondary-theme-color"
                      style="margin-left: 20px"
                    >
                      {{
                        active_sub_menu_link == "STOCKS" ? "Stocks" : "Sectors"
                      }}
                      Covered &nbsp;

                      <span class="primary-theme-color">{{
                        total_stocks_covered
                      }}</span>
                    </div>
                  </div>

                  <div class="top-margin-20">
                    <el-row>
                      <el-col
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        :xl="12"
                        class="relative"
                      >
                        <div v-if="active_performance == 'ROI'">
                          <div
                            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
                            v-if="!is_roi_graph_data_available"
                            style="top: 100px !important; left: 0; right: 0"
                          >
                            No data available
                          </div>

                          <div v-if="is_roi_graph_data_available">
                            <div class="graph-container">
                              <div
                                ref="roi_graph"
                                style="width: 100%; height: 285px"
                              ></div>
                            </div>
                          </div>
                        </div>

                        <div v-if="active_performance == 'SUCCESS_RATE'">
                          <div
                            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
                            v-if="!is_success_rate_graph_data_available"
                            style="top: 100px !important; left: 0; right: 0"
                          >
                            No data available
                          </div>

                          <div v-if="is_success_rate_graph_data_available">
                            <div class="graph-container">
                              <div
                                ref="success_rate_graph"
                                style="width: 100%; height: 285px"
                              ></div>
                            </div>

                            <!-- legends section -->
                            <div>
                              <div style="padding: 0 0 5px 0">
                                <div class="flex-space-between">
                                  <div>&nbsp;</div>
                                  <div class="font-07rem font-weight-600">
                                    Success Rate
                                  </div>
                                </div>

                                <div
                                  class="flex-space-between top-margin-10 bottom-margin-5"
                                  v-for="(item,
                                  item_index) in success_rate_pie_chart_series[0]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    class="flex cursor-pointer legend"
                                    @mouseover="
                                      highlightSuccessRateChart(
                                        item,
                                        item_index,
                                        0
                                      )
                                    "
                                    @mouseout="downSuccessRateChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem"
                                      :style="
                                        active_success_rate_inner_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div class="font-07rem">
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>

                              <div
                                class="legends-scroll-bar"
                                id="success-rate-chart-legends"
                                style="
                                        border-top: 1px solid #ddd;
                                        padding: 0 0 5px 0;
                                        height: 100px;
                                        overflow-y: auto;
                                      "
                              >
                                <div
                                  class="flex-space-between top-margin-10"
                                  v-for="(item,
                                  item_index) in success_rate_pie_chart_series[1]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    :id="+'_' + item.name + '_success_rate'"
                                    class="legend flex cursor-pointer"
                                    @mouseover="
                                      highlightSuccessRateChart(
                                        item,
                                        item_index,
                                        1
                                      )
                                    "
                                    @mouseout="downSuccessRateChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem ellipsis"
                                      style="width: 150px"
                                      :title="item.name"
                                      :style="
                                        active_success_rate_outer_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div class="font-07rem">
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="active_performance == 'ACCURACY'">
                          <div
                            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
                            v-if="!is_accuracy_graph_data_available"
                            style="top: 100px !important; left: 0; right: 0"
                          >
                            No data available
                          </div>

                          <div v-if="is_accuracy_graph_data_available">
                            <div class="graph-container">
                              <div
                                ref="accuracy_graph"
                                style="width: 100%; height: 285px"
                              ></div>
                            </div>

                            <!-- legends section -->
                            <div>
                              <div style="padding: 0 0 5px 0">
                                <div class="flex-space-between">
                                  <div>&nbsp;</div>
                                  <div class="font-07rem font-weight-600">
                                    Accuracy
                                  </div>
                                </div>

                                <div
                                  class="flex-space-between top-margin-10 bottom-margin-5"
                                  v-for="(item,
                                  item_index) in accuracy_pie_chart_series[0]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    class="flex cursor-pointer legend"
                                    @mouseover="
                                      highlightAccuracyChart(
                                        item,
                                        item_index,
                                        0
                                      )
                                    "
                                    @mouseout="downAccuracyChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem"
                                      :style="
                                        active_accuracy_inner_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div class="font-07rem">
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>

                              <div
                                class="legends-scroll-bar"
                                id="accuracy-chart-legends"
                                style="
                                        border-top: 1px solid #ddd;
                                        padding: 0 0 5px 0;
                                        height: 100px;
                                        overflow-y: auto;
                                      "
                              >
                                <div
                                  class="flex-space-between top-margin-10"
                                  v-for="(item,
                                  item_index) in accuracy_pie_chart_series[1]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    :id="+'_' + item.name + '_accuracy'"
                                    class="legend flex cursor-pointer"
                                    @mouseover="
                                      highlightAccuracyChart(
                                        item,
                                        item_index,
                                        1
                                      )
                                    "
                                    @mouseout="downAccuracyChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem ellipsis"
                                      style="width: 150px"
                                      :title="item.name"
                                      :style="
                                        active_accuracy_outer_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div class="font-07rem">
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>

                      <!-- legends section for Roi and weightage-->
                      <el-col
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        :xl="12"
                        class="relative"
                      >
                        <div class="font-08rem font-weight-500 top-margin-20">
                          <div>
                            <div style="padding: 0 0 5px 0">
                              <div class="flex-space-between">
                                <div style="width: 40%">&nbsp;</div>
                                <!-- <div
                                  class="font-07rem font-weight-600 text-center"
                                  style="width: 30%"
                                >
                                  ROI
                                </div> -->

                                <div
                                  class="font-07rem font-weight-600 text-center"
                                  style="width: 30%"
                                >
                                  Weightage
                                </div>
                              </div>

                              <div
                                class="flex-space-between top-margin-10 bottom-margin-5"
                                v-for="(item,
                                item_index) in portfolio_overview_series[0]
                                  .data"
                                :key="item_index"
                              >
                                <div
                                  class="flex cursor-pointer legend"
                                  style="width: 40%"
                                  @mouseover="
                                    highlightPortfolioChart(item, item_index, 0)
                                  "
                                  @mouseout="downPortfolioChart(item)"
                                >
                                  <div
                                    class="pie-chart-legends right-margin-10"
                                    :style="{
                                      background: item.itemStyle.color,
                                    }"
                                  ></div>

                                  <div
                                    class="font-07rem"
                                    :style="
                                      active_roi_inner_chart_legend == item.name
                                        ? { fontWeight: 600 }
                                        : {}
                                    "
                                  >
                                    {{ item.name }}
                                  </div>
                                </div>

                                <!-- <div
                                  class="font-07rem text-center"
                                  style="width: 30%"
                                >
                                  {{
                                    item.meta_data &&
                                    item.meta_data.absolute_roi
                                      ? item.meta_data.absolute_roi + "%"
                                      : "-"
                                  }}
                                </div> -->

                                <div
                                  class="font-07rem text-center"
                                  style="width: 30%"
                                >
                                  {{ item.value ? item.value + "%" : "-" }}
                                </div>
                              </div>
                            </div>

                            <div
                              class="legends-scroll-bar"
                              id="roi-chart-legends"
                              style="
                                      border-top: 1px solid #ddd;
                                      padding: 0 0 5px 0;
                                      height: 100px;
                                      overflow-y: auto;
                                    "
                            >
                              <div
                                class="flex-space-between top-margin-10"
                                v-for="(item,
                                item_index) in portfolio_overview_series[1]
                                  .data"
                                :key="item_index"
                              >
                                <div
                                  :id="+'_' + item.name + '_portfolio'"
                                  style="width: 40%"
                                  class="legend flex cursor-pointer"
                                  @mouseover="
                                    highlightPortfolioChart(item, item_index, 1)
                                  "
                                  @mouseout="downPortfolioChart(item)"
                                >
                                  <div
                                    class="pie-chart-legends right-margin-10"
                                    :style="{
                                      background: item.itemStyle.color,
                                    }"
                                  ></div>

                                  <div
                                    class="font-07rem ellipsis"
                                    style="width: 150px"
                                    :title="item.name"
                                    :style="
                                      active_roi_outer_chart_legend == item.name
                                        ? { fontWeight: 600 }
                                        : {}
                                    "
                                  >
                                    {{ item.name }}
                                  </div>
                                </div>

                                <!-- <div
                                  class="font-07rem text-center"
                                  style="width: 30%"
                                >
                                  {{
                                    item.meta_data &&
                                    item.meta_data.absolute_roi
                                      ? item.meta_data.absolute_roi + "%"
                                      : "-"
                                  }}
                                </div> -->

                                <div
                                  class="font-07rem text-center"
                                  style="width: 30%"
                                >
                                  {{ item.value ? item.value + "%" : "-" }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>

                <!-- Options section -->
                <div v-if="activeSegment == 'options'" class="options">
                  <div
                    class="flex-start top-margin-10 bottom-margin-10;padding:0px;"
                  >
                    <div
                      class="el-col el-col-24 el-col-xs-24 el-col-sm-24 el-col-md-8 el-col-lg-8 el-col-xl-8"
                      style="width: 600px"
                    >
                      <div
                        class="el-card markets-profile box-card is-always-shadow"
                        style="border-radius: 10px; margin-top: 5px; margin-bottom: 20px"
                      >
                        <!---->
                        <div class="el-card__body">
                          <div class="stock-details-section">
                            <div class="bottom-margin-10">
                              <div class="flex-space-between">
                                <div
                                  class="input-label-gray font-weight-600;font-size:14px"
                                >
                                  Total Recommendation
                                </div>
                                <div
                                  class="input-label-xs-bold-black font-07rem font-weight-600 cursor-pointer"
                                >
                                  100
                                </div>
                              </div>
                            </div>

                            <div
                              style="
                                      width: 100%;
                                      margin: 5px;
                                      height: 20px;
                                      line-height: 20px;
                                      border-radius: 50px;
                                      background: linear-gradient(
                                        to right,
                                        rgb(7, 158, 62) 73%,
                                        rgb(214, 9, 24) 73%
                                      );
                                    "
                            >
                              <div
                                class="flex-space-between"
                                style="padding-left: 0px"
                              >
                                <div
                                  style="
                                          color: rgb(255, 255, 255);
                                          font-size: 0.7rem;
                                          font-weight: bold;
                                          margin-left: 8px;
                                        "
                                >
                                  75%
                                </div>
                                <div
                                  style="
                                          color: rgb(255, 255, 255);
                                          font-size: 0.7rem;
                                          font-weight: bold;
                                          margin-right: 8px;
                                        "
                                >
                                  25%
                                </div>
                              </div>
                            </div>
                            <div class="flex relative top-margin-25">
                              <span
                                class="input-label-xs-bold-black absolute"
                                style="font-size: 0.9rem; top: -12px; left: 0px"
                              >
                                78 Advances
                              </span>

                              <span
                                class="input-label-xs-bold-black absolute"
                                style="font-size: 0.9rem; top: -12px; right: 0px"
                              >
                                22 Declines
                              </span>
                            </div>
                          </div>

                          <div class="bottom-margin-10">
                            <div
                              class="flex-space-between"
                              style="margin-top: 15px"
                            >
                              <div
                                class="input-label-gray font-weight-600;font-size:14px"
                              >
                                Live Recommendation
                              </div>
                              <div
                                class="input-label-xs-bold-black font-07rem font-weight-600 cursor-pointer"
                              >
                                4
                              </div>
                            </div>
                          </div>

                          <div class="bottom-margin-10">
                            <div
                              class="flex-space-between"
                              style="margin-top: 15px"
                            >
                              <div
                                class="input-label-gray font-weight-600;font-size:14px"
                              >
                                Latest Recommendation
                              </div>
                              <div
                                class="input-label-xs-bold-black font-07rem font-weight-600 cursor-pointer"
                              >
                                20 Sep’23
                              </div>
                            </div>
                          </div>
                          <!---->
                        </div>
                        <div class="el-loading-mask" style="display: none">
                          <div class="el-loading-spinner">
                            <svg viewBox="25 25 50 50" class="circular">
                              <circle
                                cx="50"
                                cy="50"
                                r="20"
                                fill="none"
                                class="path"
                              ></circle>
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-row>
                    <el-col style="width: 180px" class="bottom-margin-10">
                      <div
                        class="performance-count cursor-pointer"
                        @click="setActivePerformanceLink('ROI')"
                        :style="[
                          active_performance == 'ROI'
                            ? { background: '#E9F3FF' }
                            : { background: '#f8f9fa' },
                        ]"
                      >
                        <div class="flex">
                          <img
                            src="../assets/images/stockantsoverview/ROI Icon.svg"
                            width="18"
                            height="22"
                          />

                          <span style="margin-left: 5px; color: #2488ff"
                            >ROI</span
                          >
                        </div>

                        <div
                          style="color: #079e3e; font-weight: 500; font-size: 15px"
                        >
                          {{
                            expert_details.absolute_roi
                              ? expert_details.absolute_roi + "%"
                              : "NA"
                          }}
                          <!-- 15.31% -->
                        </div>
                      </div>
                    </el-col>

                    <el-col style="width: 180px" class="bottom-margin-10">
                      <div
                        class="performance-count cursor-pointer"
                        @click="setActivePerformanceLink('SUCCESS_RATE')"
                        :style="[
                          active_performance == 'SUCCESS_RATE'
                            ? { background: '#F4F4F4' }
                            : { background: '#f8f9fa' },
                        ]"
                      >
                        <div class="flex">
                          <img
                            src="../assets/images/stockantsoverview/Success rate Icon.svg"
                            width="18"
                          />

                          <span style="margin-left: 5px; color: #757575"
                            >Success</span
                          >
                        </div>

                        <div
                          style="color: #079e3e; font-weight: 500; font-size: 15px"
                        >
                          {{
                            expert_details.success_rate
                              ? expert_details.success_rate + "%"
                              : "NA"
                          }}
                          <!-- 49.94% -->
                        </div>
                      </div>
                    </el-col>
                  </el-row>

                  <div class="flex top-margin-25">
                    <!-- <div class="font-08rem font-weight-600">Portfolio Overview</div> -->

                    <div class="flex" style="margin-left: 20px">
                      <div
                        class="sub-menu-bar-link cursor-pointer"
                        @click="setActiveSubMenuLink('STOCKS')"
                        :class="{
                          'active-sub-menu-link':
                            active_sub_menu_link == 'STOCKS',
                        }"
                      >
                        Stocks
                      </div>

                      <div
                        class="sub-menu-bar-link cursor-pointer"
                        @click="setActiveSubMenuLink('SECTOR')"
                        :class="{
                          'active-sub-menu-link':
                            active_sub_menu_link == 'SECTOR',
                        }"
                      >
                        Sector
                      </div>
                    </div>

                    <div
                      class="font-08rem font-weight-600 secondary-theme-color"
                      style="margin-left: 20px"
                    >
                      {{
                        active_sub_menu_link == "STOCKS" ? "Stocks" : "Sectors"
                      }}
                      Covered &nbsp;

                      <span class="primary-theme-color">{{
                        total_stocks_covered
                      }}</span>
                    </div>
                  </div>

                  <div class="top-margin-20">
                    <el-row>
                      <el-col
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        :xl="12"
                        class="relative"
                      >
                        <div v-if="active_performance == 'ROI'">
                          <div
                            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
                            v-if="!is_roi_graph_data_available"
                            style="top: 100px !important; left: 0; right: 0"
                          >
                            No data available
                          </div>

                          <div v-if="is_roi_graph_data_available">
                            <div class="graph-container">
                              <div
                                ref="roi_graph"
                                style="width: 100%; height: 285px"
                              ></div>
                            </div>

                            <!-- legends section -->
                            <div>
                              <div style="padding: 0 0 5px 0">
                                <div class="flex-space-between">
                                  <div style="width: 40%">&nbsp;</div>
                                  <div
                                    class="font-07rem font-weight-600 text-center"
                                    style="width: 30%"
                                  >
                                    ROI
                                  </div>
                                  <div
                                    class="font-07rem font-weight-600 text-center"
                                    style="width: 30%"
                                  >
                                    Weightage
                                  </div>
                                </div>

                                <div
                                  class="flex-space-between top-margin-10 bottom-margin-5"
                                  v-for="(item,
                                  item_index) in portfolio_overview_series[0]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    class="flex cursor-pointer legend"
                                    style="width: 40%"
                                    @mouseover="
                                      highlightPortfolioChart(
                                        item,
                                        item_index,
                                        0
                                      )
                                    "
                                    @mouseout="downPortfolioChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem"
                                      :style="
                                        active_roi_inner_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div
                                    class="font-07rem text-center"
                                    style="width: 30%"
                                  >
                                    {{
                                      item.meta_data &&
                                      item.meta_data.absolute_roi
                                        ? item.meta_data.absolute_roi + "%"
                                        : "-"
                                    }}
                                  </div>

                                  <div
                                    class="font-07rem text-center"
                                    style="width: 30%"
                                  >
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>

                              <div
                                class="legends-scroll-bar"
                                id="roi-chart-legends"
                                style="
                                        border-top: 1px solid #ddd;
                                        padding: 0 0 5px 0;
                                        height: 100px;
                                        overflow-y: auto;
                                      "
                              >
                                <div
                                  class="flex-space-between top-margin-10"
                                  v-for="(item,
                                  item_index) in portfolio_overview_series[1]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    :id="+'_' + item.name + '_portfolio'"
                                    style="width: 40%"
                                    class="legend flex cursor-pointer"
                                    @mouseover="
                                      highlightPortfolioChart(
                                        item,
                                        item_index,
                                        1
                                      )
                                    "
                                    @mouseout="downPortfolioChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem ellipsis"
                                      style="width: 150px"
                                      :title="item.name"
                                      :style="
                                        active_roi_outer_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div
                                    class="font-07rem text-center"
                                    style="width: 30%"
                                  >
                                    {{
                                      item.meta_data &&
                                      item.meta_data.absolute_roi
                                        ? item.meta_data.absolute_roi + "%"
                                        : "-"
                                    }}
                                  </div>

                                  <div
                                    class="font-07rem text-center"
                                    style="width: 30%"
                                  >
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="active_performance == 'SUCCESS_RATE'">
                          <div
                            class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20 absolute"
                            v-if="!is_success_rate_graph_data_available"
                            style="top: 100px !important; left: 0; right: 0"
                          >
                            No data available
                          </div>

                          <div v-if="is_success_rate_graph_data_available">
                            <div class="graph-container">
                              <div
                                ref="success_rate_graph"
                                style="width: 100%; height: 285px"
                              ></div>
                            </div>

                            <!-- legends section -->
                            <div>
                              <div style="padding: 0 0 5px 0">
                                <div class="flex-space-between">
                                  <div>&nbsp;</div>
                                  <div class="font-07rem font-weight-600">
                                    Success Rate
                                  </div>
                                </div>

                                <div
                                  class="flex-space-between top-margin-10 bottom-margin-5"
                                  v-for="(item,
                                  item_index) in success_rate_pie_chart_series[0]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    class="flex cursor-pointer legend"
                                    @mouseover="
                                      highlightSuccessRateChart(
                                        item,
                                        item_index,
                                        0
                                      )
                                    "
                                    @mouseout="downSuccessRateChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem"
                                      :style="
                                        active_success_rate_inner_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div class="font-07rem">
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>

                              <div
                                class="legends-scroll-bar"
                                id="success-rate-chart-legends"
                                style="
                                        border-top: 1px solid #ddd;
                                        padding: 0 0 5px 0;
                                        height: 100px;
                                        overflow-y: auto;
                                      "
                              >
                                <div
                                  class="flex-space-between top-margin-10"
                                  v-for="(item,
                                  item_index) in success_rate_pie_chart_series[1]
                                    .data"
                                  :key="item_index"
                                >
                                  <div
                                    :id="+'_' + item.name + '_success_rate'"
                                    class="legend flex cursor-pointer"
                                    @mouseover="
                                      highlightSuccessRateChart(
                                        item,
                                        item_index,
                                        1
                                      )
                                    "
                                    @mouseout="downSuccessRateChart(item)"
                                  >
                                    <div
                                      class="pie-chart-legends right-margin-10"
                                      :style="{
                                        background: item.itemStyle.color,
                                      }"
                                    ></div>

                                    <div
                                      class="font-07rem ellipsis"
                                      style="width: 150px"
                                      :title="item.name"
                                      :style="
                                        active_success_rate_outer_chart_legend ==
                                        item.name
                                          ? { fontWeight: 600 }
                                          : {}
                                      "
                                    >
                                      {{ item.name }}
                                    </div>
                                  </div>

                                  <div class="font-07rem">
                                    {{ item.value ? item.value + "%" : "-" }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>

                      <!-- short term and long term wise roi -->
                      <el-col
                        :xs="24"
                        :sm="12"
                        :md="12"
                        :lg="12"
                        :xl="12"
                        class="relative"
                      >
                        <div
                          class="text-center primary-theme-color font-08rem font-weight-500 top-margin-20"
                          v-if="!is_reco_count_data_available"
                        >
                          No data available
                        </div>

                        <div v-if="is_reco_count_data_available">
                          <div class="graph-container">
                            <div
                              ref="reco_count_graph"
                              style="width: 100%; height: 285px"
                            ></div>
                          </div>

                          <div class="flex-center">
                            <div
                              class="flex-space-between top-margin-10 bottom-margin-5"
                              v-for="(item, item_index) in reco_count_series[0]
                                .data"
                              :key="item_index"
                              :style="[
                                item_index ? { marginLeft: '15px' } : {},
                              ]"
                            >
                              <div
                                class="flex cursor-pointer legend"
                                @mouseover="
                                  highlightRecoCountChart(item, item_index)
                                "
                                @mouseout="downRecoCountChart(item)"
                              >
                                <div
                                  class="pie-chart-legends right-margin-10"
                                  :style="{
                                    background: item.itemStyle.color,
                                  }"
                                ></div>

                                <div
                                  class="font-07rem"
                                  :style="
                                    active_reco_count_chart_legend == item.name
                                      ? { fontWeight: 600 }
                                      : {}
                                  "
                                >
                                  {{ item.name }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </div>
                <!-- options section complte -->
              </el-card>
            </el-col>
          </el-row>
        </div>
        <!-- </div> -->
      </el-col>
      <el-col :xs="0" :sm="1" :md="2" :lg="2" :xl="2">&nbsp;</el-col>
    </el-row>

    <!-- write review dialog -->
    <el-dialog
      title="Write your review"
      :visible.sync="write_review_dialog_visibility"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :lock-scroll="true"
      class=""
      :before-close="closeWriteReviewDialog"
    >
      <div>
        <el-row>
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div
              class="form-group"
              :class="{
                'not-empty': review_title.length,
                'form-group--error': $v.review_title.$error,
              }"
            >
              <div class="sub-title bottom-margin-5 inline-block">
                Review title
              </div>
              &nbsp;<span class="required-field">*</span>
              <el-input
                placeholder="Title"
                v-model="review_title"
                size="small"
              ></el-input>
            </div>

            <div class="error" v-if="!$v.review_title.required">
              Field is required
            </div>
          </el-col>
        </el-row>

        <el-row class="top-margin-15">
          <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
            <div
              class="form-group"
              :class="{
                'not-empty': review.length,
                'form-group--error': $v.review.$error,
              }"
            >
              <div class="sub-title bottom-margin-5 inline-block">
                Write a review
              </div>
              &nbsp;<span class="required-field">*</span>

              <el-input
                type="textarea"
                resize="none"
                v-model="review"
                cols="30"
                rows="5"
                maxlength="200"
                placeholder="Max 200 words"
              >
              </el-input>
            </div>

            <div class="error" v-if="!$v.review.required">
              Field is required
            </div>
          </el-col>
        </el-row>

        <div class="top-margin-15" style="display: flex">
          <el-checkbox v-model="checked" class="right-margin-10"></el-checkbox>
          <div class="font-07rem" style="text-align: justify">
            I certify that this review is based on my own experience and is my
            genuine opinion for this expert <br />
            and that I have not been offered anyincentive and payment
            originating from the establishment <br />
            to write this review. I understand that StockAnts has a
            zero-tolerance policy on fake reviews.
          </div>
        </div>
      </div>
      <div class="top-margin-20">
        <el-button
          round
          class="btn-theme-borderd"
          size="mini"
          @click="submitReview()"
          :disabled="!review_title || !review || !checked"
          :loading="is_review_submit_in_progress"
          >SUBMIT</el-button
        >
      </div>
    </el-dialog>

    <div id="video-section">
      <el-dialog
        :visible.sync="videoDialog"
        :before-close="videoDialogClose"
        center
      >
        <div class="iframe-container">
          <iframe
            id="videoId"
            width="100%"
            height="600px"
            src="https://www.youtube.com/embed/umwESJwcelY"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import { screenSize } from "../mixins/ScreenSize.js";
import PlainSideBar from "@/components/PlainSideBar.vue";
import MobileNav from "@/components/MobileNav.vue";
import CripNotice from "crip-vue-notice";
import NoDataFound from "@/components/NoDataFound.vue";
import Hexagon from "@/components/Hexagon.vue";
import ExpertHubProfileCard from "@/components/ExpertHubProfileCard.vue";
import { required } from "vuelidate/lib/validators";
import { graphData } from "../mixins/BarGraphData";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
//import axios from "axios";
import { EventBus } from "../eventBus";
import LockSection from "@/components/LockSection.vue";

export default {
  name: "StockAntsOverview",

  mixins: [filterCallBack, screenSize, graphData, HelperNetworkCallBack],

  components: {
    ExpertHubProfileCard,
    Hexagon,
    PlainSideBar,
    MobileNav,
    NoDataFound,
    LockSection,
  },

  data() {
    return {
      showDialog: false,
      videoDialog: false,
      nav_title: "Expert Cover Page",
      expert_details: {},
      user_id: "",
      user_type: "",
      // user_profession: [],
      is_following: false,
      write_review_dialog_visibility: false,
      is_review_section_loading: false,
      is_recommended_experts_list_loading: false,
      review_per_page: 3,
      total_review_pages: null,
      review_current_page_no: 1,
      total_reviews: null,
      access_code: "",
      is_expert_has_access_to_dashboard: false,
      is_access_code_verifying: false,
      star_rating: null,
      review_title: "",
      review: "",
      checked: false,
      review_section_collapse: 1,
      is_expert_details_loading: false,
      is_review_submit_in_progress: false,
      review_list: [],
      page_no: 1,
      number_of_pages: null,
      page_per_entries: 3,
      active_carousel_item: 0,
      active_sub_menu_link: "STOCKS",
      active_performance: "ROI",
      active_period: "1M",
      is_roi_graph_data_available: true,
      is_success_rate_graph_data_available: true,
      is_accuracy_graph_data_available: true,
      is_reco_count_data_available: true,
      roi_graph_instance: null,
      accuracy_graph_instance: null,
      success_rate_graph_instance: null,
      reco_count_graph_instance: null,
      active_roi_inner_chart_legend: "",
      active_roi_outer_chart_legend: "",
      active_accuracy_inner_chart_legend: "",
      active_accuracy_outer_chart_legend: "",
      active_success_rate_inner_chart_legend: "",
      active_success_rate_outer_chart_legend: "",
      active_reco_count_chart_legend: "",
      total_stocks_covered: 0,
      moment: moment,
      serverHostName: serverHostName,
      activeSegment: "equity",
      stocks: [],
      advancesCount: 0,
      declinesCount: 0,
      loading: true,
      showLockSection: false,

      // showEquityDiv: true,
      // showOptionsDiv: false,

      performanceData: {
        Advances: 0,
        Declines: 0,
      },

      expertDetails: {
        absoluteRoi: null,
        successRate: null,
      },
      company_id: null,
    };
  },

  validations: {
    review_title: {
      required,
    },
    review: {
      required,
    },
    access_code: {
      required,
    },
  },

  beforeRouteEnter(to, from, next) {
    let user_id = from.query.user_id
      ? from.query.user_id
      : to.query.user_id
      ? to.query.user_id
      : null;

    // if user is logged in user then redirect it to dashboard analytics page
    if (user_id) {
      if (JSON.parse(localStorage.getItem("profile")).profile_id == user_id) {
        next({ name: "dashboardAnalytics" });
      }
    }

    next();
  },

  created() {
    if (localStorage.getItem("access_to_expert_dashboard") == this.user_id) {
      this.is_expert_has_access_to_dashboard = true;
    }
  },
  beforeCreate() {
    if (localStorage.getItem("profile")) {
      setTimeout(() => {
        var websiteUserType = localStorage.getItem("websiteUserType")
          ? JSON.parse(localStorage.getItem("websiteUserType"))
          : {};
        var userProfile = JSON.parse(localStorage.getItem("profile"));

        var internalTeamList = [
          "krishaa0801@gmail.com",
          "joshiakshay719@gmail.com",
          "fegde.mayur@gmail.com",
          "snehalvpatil25@gmail.com",
          "sumittarkas0001@gmail.com",
          "bid.pallavi@gmail.com",
          "pallavi.bid@stockants.com",
          "bhushanm705811@gmail.com",
          "admin@stockants.com",
          "sumittarkas001@gmail.com",
          "satavchetan08@gmail.com",
          "amanm3047@gmail.com",
        ];

        userProfile.email = userProfile.email.toLowerCase();

        if (
          websiteUserType &&
          websiteUserType.userType == "stockAnts" &&
          internalTeamList.includes(userProfile.email)
        ) {
          this.isAdmin = true;
        }
      }, 0);
    }
  },

  mounted() {
    // Check user's plan in localStorage
    const planDetails = localStorage.getItem("plan_details");
    if (planDetails && JSON.parse(planDetails).plan === "Lite") {
      this.showLockSection = true;
    }

    if (this.$store.state.dashboardActivePeriod) {
      this.active_period = this.$store.state.dashboardActivePeriod;
    }

    if (this.$route.query.user && this.$route.query.user_id) {
      this.user_type = this.$route.query.user;
      this.user_id = this.$route.query.user_id;
      // this.user_profession = this.$route.query.profession;

      this.initRoiGraphInstance();
      // this.initRecoCountGraphInstance();
      this.combinedApis();
    }

    this.handleReivewPageCurrentPageChange();
    this.setActivePerformanceLink("ROI");
    this.fetchStockData();
    this.getAdvancesAndDeclinesNetWorkCallBack();
    this.getOverviewDetails();
  },

  methods: {
    handleClose() {
      this.showDialog = false;
    },
    videoDialogClose() {
      this.videoDialog = false;
      let video = document.getElementById("videoId");
      let url = video.getAttribute("src");
      video.setAttribute("src", "");
      video.setAttribute("src", url);
    },
    getAdvancesPercentage() {
      var advanceCalc =
        this.performanceData.Advances /
        (this.performanceData.Advances + this.performanceData.Declines);

      return advanceCalc != 0 ? (advanceCalc * 100).toFixed() : 0;
    },

    // method for redirect on price section after subscribe button click
    goToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },

    async fetchStockData() {
      try {
        const response = await serverAddr.post(
          "/overview/equity/v1/top_picks",
          {}
        );
        const data = response.data;
        this.stocks = data.data;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    //  api for absolute Roi & success rate overview details
    async getOverviewDetails() {
      try {
        const response = await serverAddr.post(`/overview/detail`, {
          period: this.active_period,
        });
        const data = response.data;

        this.expertDetails.absoluteRoi = data.data.absolute_roi;
        this.expertDetails.successRate = data.data.success_rate;

        this.company_id = data.data.company_id;
      } catch (error) {
        console.error(error);
      }
    },

    async getAdvancesAndDeclinesNetWorkCallBack() {
      try {
        const response = await serverAddr.post(`/overview/wheel_performance`, {
          period: this.active_period,
        });
        const data = response.data;

        this.performanceData.Advances = data.status_counts.Advances;
        this.performanceData.Declines = data.status_counts.Declines;
        this.performanceData.TotalRecommendation = data.total_reco_count;
        this.performanceData.LiveRecommendation =
          data.live_recommendations_count;
        this.performanceData.LatestRecommendation =
          data.latest_recommendation_date;
      } catch (error) {
        console.error(error);
      }
    },

    changeActiveSegment(segment) {
      this.activeSegment = segment;
    },

    //initialize graph
    initRoiGraphInstance() {
      // for roi chart
      let roi_graph_container = this.$refs["roi_graph"];
      this.roi_graph_instance = echarts.init(
        roi_graph_container,
        null,
        this.initOptions
      );

      this.roi_graph_instance.on(
        "mouseover",
        { seriesIndex: 1 },
        function(params) {
          this.active_roi_inner_chart_legend = params.data.name; //on chart hovered assigned hovered chart name
          this.active_roi_outer_chart_legend = params.data.name; //on chart hovered assigned hovered chart name

          if (params.seriesIndex) {
            var elem = document.getElementById("roi-chart-legends");
            elem.scroll(0, params.dataIndex * 24);
          }
        }.bind(this)
      );

      this.roi_graph_instance.on(
        "mouseout",
        function(params) {
          this.active_roi_inner_chart_legend = "";
          this.active_roi_outer_chart_legend = "";
        }.bind(this)
      );
    },

    initSuccessRateGraphInstance() {
      // for success rate chart
      let success_rate_graph_container = this.$refs["success_rate_graph"];
      this.success_rate_graph_instance = echarts.init(
        success_rate_graph_container,
        null,
        this.initOptions
      );

      this.success_rate_graph_instance.on(
        "mouseover",
        { seriesIndex: 1 },
        function(params) {
          this.active_success_rate_inner_chart_legend = params.data.name; //on chart hovered assigned hovered chart name
          this.active_success_rate_outer_chart_legend = params.data.name; //on chart hovered assigned hovered chart name

          if (params.seriesIndex) {
            var elem = document.getElementById("success-rate-chart-legends");
            // elem.scroll(0, params.dataIndex * 24);
          }
        }.bind(this)
      );

      this.success_rate_graph_instance.on(
        "mouseout",
        function(params) {
          this.active_success_rate_inner_chart_legend = "";
          this.active_success_rate_outer_chart_legend = "";
        }.bind(this)
      );
    },

    clearRoiGraphData() {
      this.portfolio_overview_series[0].data = [];
      this.portfolio_overview_series[1].data = [];
      this.reRenderRoiGraphInstance();
    },

    // refresh protfolio overview graph instance
    clearRoiGraphInstance: function() {
      this.roi_graph_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderRoiGraphInstance: function() {
      this.clearRoiGraphInstance();
      this.roi_graph_instance.setOption(this.protfolidOverviewGraph);
    },

    //clears success rate graph data e.g. x_axis, y_axis etc
    clearSuccessRateGraphData() {
      this.success_rate_pie_chart_series[0].data = [];
      this.success_rate_pie_chart_series[1].data = [];
      this.reRenderSuccessRateGraphInstance();
    },

    //refresh success rate graph instance
    clearSuccessRateGraphInstance: function() {
      this.success_rate_graph_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderSuccessRateGraphInstance: function() {
      this.clearSuccessRateGraphInstance();
      this.success_rate_graph_instance.setOption(this.successRatePieChart);
    },

    // cleares graph data e.g. x_axis, y_axis, legends
    clearAccuracyGraphData() {
      this.accuracy_pie_chart_series[0].data = [];
      this.accuracy_pie_chart_series[1].data = [];
      // this.horizontal_bar_graph_yaxis_A.data = [];
      // this.horizontal_bar_graph_series_A[0].data = [];
      this.reRenderAccuracyGraphInstance();
    },

    //refresh graph instance
    clearAccuracyGraphInstance: function() {
      this.accuracy_graph_instance.clear();
    },

    //to trigger changes on graph e.g. to reflect changes data
    reRenderAccuracyGraphInstance: function() {
      this.clearAccuracyGraphInstance();
      // this.accuracy_graph_instance.setOption(this.horizontalBarGraphPartA);
      this.accuracy_graph_instance.setOption(this.accuracyPieChart);
    },

    selectPeriod(period) {
      if (period == "1M") {
        this.active_period = "1M";
      } else if (period == "3M") {
        this.active_period = "3M";
      } else if (period == "6M") {
        this.active_period = "6M";
      } else if (period == "1Y") {
        this.active_period = "1Y";
      } else if (period == "MAX") {
        this.active_period = "MAX";
      }

      this.setActivePerformanceLink(this.active_performance); //on period changed called portfolio apis
      this.getAdvancesAndDeclinesNetWorkCallBack();
      this.getOverviewDetails();
      // this.getExpertDetails();
    },

    setActiveSubMenuLink(label) {
      if (label == "STOCKS") {
        this.active_sub_menu_link = "STOCKS";
      } else if (label == "SECTOR") {
        this.active_sub_menu_link = "SECTOR";
      }

      setTimeout(() => {
        this.setActivePerformanceLink(this.active_performance); //on stock and sector change called portfolio apis
      }, 200);
    },

    setActivePerformanceLink(label) {
      if (label == "ROI") {
        this.active_performance = "ROI";

        this.is_roi_graph_data_available = true;

        setTimeout(() => {
          this.initRoiGraphInstance();

          this.roi_graph_instance.showLoading(this.loader_default); //enabled loader

          this.clearRoiGraphData();
        }, 100);

        setTimeout(async () => {
          let response = await this.getRoiGraphData();

          if (response.data.status && response.data.data.length) {
            this.total_stocks_covered = 0; //reset covered stocks to 0

            for (let i = 0; i < response.data.data.length; i++) {
              // for inner success rate chart - small cap, large cap, mid cap
              if (response.data.data[i].label) {
                let obj = {
                  name: response.data.data[i].label,
                  value: response.data.data[i].weightage,
                  itemStyle: {
                    color:
                      response.data.data[i].label == "Small Cap"
                        ? "#0d6972"
                        : response.data.data[i].label == "Mid Cap"
                        ? "#117a93"
                        : response.data.data[i].label == "Large Cap"
                        ? "#096ad0"
                        : "",
                  },
                  meta_data: response.data.data[i],
                };

                this.portfolio_overview_series[0].data.push(obj);

                let total_count =
                  this.active_sub_menu_link == "STOCKS"
                    ? response.data.data[i].stock_cover
                    : response.data.data[i].sector_cover;

                this.total_stocks_covered =
                  this.total_stocks_covered + total_count;
              }

              let data =
                this.active_sub_menu_link == "STOCKS"
                  ? response.data.data[i].stock_data
                  : response.data.data[i].sector_data;

              for (let j = 0; j < data.length; j++) {
                // for outer success rate chart - stock list
                let stock_obj = {
                  name: data[j].name,
                  value: data[j].weightage,
                  itemStyle: {
                    color: this.chart_colors[
                      this.portfolio_overview_series[1].data.length
                    ],
                  },
                  meta_data: data[j],
                };

                this.portfolio_overview_series[1].data.push(stock_obj);
              }
            }
          } else {
            this.is_roi_graph_data_available = false;
          }

          this.reRenderRoiGraphInstance();
          this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader
        }, 300);
      } else if (label == "SUCCESS_RATE") {
        this.active_performance = "SUCCESS_RATE";

        this.is_success_rate_graph_data_available = true;

        setTimeout(() => {
          this.initSuccessRateGraphInstance();

          this.success_rate_graph_instance.showLoading(this.loader_default); //enabled loader

          this.clearSuccessRateGraphData();
        }, 100);

        setTimeout(async () => {
          let response = await this.getSuccessRateGraphData();

          if (response.data.status && response.data.data.length) {
            this.total_stocks_covered = 0; //reset covered stocks to 0

            for (let i = 0; i < response.data.data.length; i++) {
              // for inner success rate chart - small cap, large cap, mid cap
              if (response.data.data[i].label) {
                let obj = {
                  name: response.data.data[i].label,
                  value: response.data.data[i].success_rate,
                  itemStyle: {
                    color:
                      response.data.data[i].label == "Small Cap"
                        ? "#0d6972"
                        : response.data.data[i].label == "Mid Cap"
                        ? "#117a93"
                        : response.data.data[i].label == "Large Cap"
                        ? "#096ad0"
                        : "",
                  },
                };

                this.success_rate_pie_chart_series[0].data.push(obj);

                let total_count =
                  this.active_sub_menu_link == "STOCKS"
                    ? response.data.data[i].stock_cover
                    : response.data.data[i].sector_cover;

                this.total_stocks_covered =
                  this.total_stocks_covered + total_count;
              }

              let data =
                this.active_sub_menu_link == "STOCKS"
                  ? response.data.data[i].stock_data
                  : response.data.data[i].sector_data;

              for (let j = 0; j < data.length; j++) {
                // for outer success rate chart - stock list
                let stock_obj = {
                  name: data[j].name,
                  value: data[j].success_rate,
                  itemStyle: {
                    color: this.chart_colors[
                      this.success_rate_pie_chart_series[1].data.length
                    ],
                  },
                };

                this.success_rate_pie_chart_series[1].data.push(stock_obj);
              }
            }
          } else {
            this.is_success_rate_graph_data_available = false;
          }

          this.reRenderSuccessRateGraphInstance();
          this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader
        }, 300);
      } else if (label == "ACCURACY") {
        this.active_performance = "ACCURACY";

        this.is_accuracy_graph_data_available = true;

        setTimeout(() => {
          this.initAccuracyGraphInstance();

          this.accuracy_graph_instance.showLoading(this.loader_default); //disabled loader

          this.clearAccuracyGraphData();
        }, 100);

        setTimeout(async () => {
          let response = await this.getAccuracyGraphData();

          if (response.data.status && response.data.data.length) {
            this.total_stocks_covered = 0; //reset covered stocks to 0

            for (let i = 0; i < response.data.data.length; i++) {
              // for inner success rate chart - small cap, large cap, mid cap
              if (response.data.data[i].label) {
                let obj = {
                  name: response.data.data[i].label,
                  value: response.data.data[i].avg_accuracy,
                  itemStyle: {
                    color:
                      response.data.data[i].label == "Small Cap"
                        ? "#0d6972"
                        : response.data.data[i].label == "Mid Cap"
                        ? "#117a93"
                        : response.data.data[i].label == "Large Cap"
                        ? "#096ad0"
                        : "",
                  },
                };

                this.accuracy_pie_chart_series[0].data.push(obj);

                let total_count =
                  this.active_sub_menu_link == "STOCKS"
                    ? response.data.data[i].stock_cover
                    : response.data.data[i].sector_cover;

                this.total_stocks_covered =
                  this.total_stocks_covered + total_count;
              }

              let data =
                this.active_sub_menu_link == "STOCKS"
                  ? response.data.data[i].stock_data
                  : response.data.data[i].sector_data;

              for (let j = 0; j < data.length; j++) {
                // for outer success rate chart - stock list
                let stock_obj = {
                  name: data[j].name,
                  value: data[j].avg_accuracy,
                  itemStyle: {
                    color: this.chart_colors[
                      this.accuracy_pie_chart_series[1].data.length
                    ],
                  },
                };

                this.accuracy_pie_chart_series[1].data.push(stock_obj);
              }
            }
          } else {
            this.is_accuracy_graph_data_available = false;
          }

          this.reRenderAccuracyGraphInstance();
          this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader
        }, 300);
      }

      // if(this.active_sub_menu_link == 'SECTOR'){
      // for reco count graph
      this.is_reco_count_data_available = true;

      // setTimeout(() => {
      //   this.initRecoCountGraphInstance();

      //   // this.reco_count_graph_instance.showLoading(this.loader_default); //enabled loader
      // }, 100);

      setTimeout(async () => {
        let response = await this.getRecommendationCount();

        if (response.data.status && response.data.data.length) {
          this.reco_count_series[0].data = [];

          for (let i = 0; i < response.data.data.length; i++) {
            if (response.data.data[i].term == "Short term") {
              let obj = {
                value: response.data.data[i].total_reco,
                name: "Short Term",
                itemStyle: { color: "#d3d3d3" },
                meta_data: response.data.data[i].absolute_roi,
              };
              this.reco_count_series[0].data.push(obj);
            }

            if (response.data.data[i].term == "Long term") {
              let obj = {
                value: response.data.data[i].total_reco,
                name: "Long Term",
                itemStyle: { color: "#565656" },
                meta_data: response.data.data[i].absolute_roi,
              };
              this.reco_count_series[0].data.push(obj);
            }
          }
        } else {
          this.is_reco_count_data_available = false;
          this.reco_count_series[0].data = [];
          // this.reco_count_graph_instance.hideLoading(this.loader_default); //disabled loader
        }
      }, 300);

      // }
    },

    async handleReivewPageCurrentPageChange() {
      this.is_review_section_loading = true; //enabled loader
      this.review_list = [];

      let review_res = await this.getAllReviews();

      if (review_res.data.status && review_res.data.data.length) {
        review_res.data.data.forEach((e) => {
          let obj = {};
          (obj.profile_pic = e.pic),
            (obj.name = e.created_by.first_name + " " + e.created_by.last_name),
            (obj.designation = e.creator_profession),
            (obj.rating = e.rating),
            (obj.review_title = e.title),
            (obj.review = e.comment),
            (obj.date = e.review_date),
            (obj.replied_users = e.replied_users);

          this.review_list.push(obj);
        });

        this.total_review_pages = review_res.data.pagination.total_pages;
        this.total_reviews = review_res.data.pagination.total_entries;
        this.review_current_page_no = review_res.data.pagination.current_page;

        this.is_review_section_loading = false; //disabled loader
      }
    },

    openReviewDialog() {
      this.review_title = "";
      this.review = "";
      this.checked = false;
      this.write_review_dialog_visibility = true;
    },

    closeWriteReviewDialog() {
      this.write_review_dialog_visibility = false;
    },

    combinedApis() {
      this.review_list = [];
      this.total_stocks_covered = 0; //reset covered stocks to 0

      this.is_expert_details_loading = true; //enabled loader
      this.roi_graph_instance.showLoading(this.loader_default); //enabled loader

      this.is_reco_count_data_available = true;
      this.reco_count_graph_instance.showLoading(this.loader_default); //enabled loader

      this.getExpertDetails(),
        axios
          .all([
            this.getAllReviews(),
            this.getUserRating(),
            this.sendVisitorsTrackToServer(),
            this.getRoiGraphData(),
            this.getRecommendationCount(),
          ])
          .then(
            axios.spread(
              (
                reviewList,
                userRatingRes,
                visitorsTrackRes,
                roiGraphRes,
                recoCountRes
              ) => {
                // for review details
                if (reviewList.data.status && reviewList.data.data.length) {
                  reviewList.data.data.forEach((e) => {
                    let obj = {};
                    (obj.profile_pic = e.pic),
                      (obj.name =
                        e.created_by.first_name + " " + e.created_by.last_name),
                      (obj.designation = e.creator_profession),
                      (obj.rating = e.rating),
                      (obj.review_title = e.title),
                      (obj.review = e.comment),
                      (obj.date = e.review_date),
                      (obj.replied_users = e.replied_users);

                    this.review_list.push(obj);
                  });

                  this.total_review_pages =
                    reviewList.data.pagination.total_pages;
                  this.total_reviews = reviewList.data.pagination.total_entries;
                  this.review_current_page_no =
                    reviewList.data.pagination.current_page;
                }

                if (userRatingRes.data.status) {
                  this.star_rating = userRatingRes.data.data.rating;
                }

                // for roi graph
                if (roiGraphRes.data.status && roiGraphRes.data.data.length) {
                  this.clearRoiGraphData();

                  for (let i = 0; i < roiGraphRes.data.data.length; i++) {
                    // for inner success rate chart - small cap, large cap, mid cap
                    if (roiGraphRes.data.data[i].label) {
                      this.total_stocks_covered =
                        this.total_stocks_covered +
                        roiGraphRes.data.data[i].stock_cover;

                      let obj = {
                        name: roiGraphRes.data.data[i].label,
                        value: roiGraphRes.data.data[i].weightage,
                        itemStyle: {
                          color:
                            roiGraphRes.data.data[i].label == "Small Cap"
                              ? "#0d6972"
                              : roiGraphRes.data.data[i].label == "Mid Cap"
                              ? "#117a93"
                              : roiGraphRes.data.data[i].label == "Large Cap"
                              ? "#096ad0"
                              : "",
                        },
                        meta_data: roiGraphRes.data.data[i],
                      };

                      this.portfolio_overview_series[0].data.push(obj);
                    }

                    for (
                      let j = 0;
                      j < roiGraphRes.data.data[i].stock_data.length;
                      j++
                    ) {
                      // for outer success rate chart - stock list
                      let stock_obj = {
                        name: roiGraphRes.data.data[i].stock_data[j].name,
                        value: roiGraphRes.data.data[i].stock_data[j].weightage,
                        itemStyle: {
                          color: this.chart_colors[
                            this.portfolio_overview_series[1].data.length
                          ],
                        },
                        meta_data: roiGraphRes.data.data[i].stock_data[j],
                      };

                      this.portfolio_overview_series[1].data.push(stock_obj);
                    }
                  }
                } else {
                  this.clearRoiGraphData(); //clear graph data e.g. xaxis, yaxis, series

                  this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader

                  this.is_roi_graph_data_available = false;
                }

                this.reRenderRoiGraphInstance();
                this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader

                // for reco count graph
                if (recoCountRes.data.status && recoCountRes.data.data.length) {
                  this.reco_count_series[0].data = [];

                  for (let i = 0; i < recoCountRes.data.data.length; i++) {
                    if (recoCountRes.data.data[i].term == "Short term") {
                      let obj = {
                        value: recoCountRes.data.data[i].total_reco,
                        name: "Short Term",
                        itemStyle: { color: "#d3d3d3" },
                        meta_data: recoCountRes.data.data[i].absolute_roi,
                      };
                      this.reco_count_series[0].data.push(obj);
                    }

                    if (recoCountRes.data.data[i].term == "Long term") {
                      let obj = {
                        value: recoCountRes.data.data[i].total_reco,
                        name: "Long Term",
                        itemStyle: { color: "#565656" },
                        meta_data: recoCountRes.data.data[i].absolute_roi,
                      };
                      this.reco_count_series[0].data.push(obj);
                    }
                  }
                } else {
                  this.is_reco_count_data_available = false;
                  this.reco_count_series[0].data = [];
                }

                this.is_expert_details_loading = false; //enabled loader
              }
            )
          )
          .catch((err) => {
            console.log(err);
            this.is_expert_details_loading = false; //enabled loader
            this.review_list = [];
          })
          .finally(() => {
            this.is_expert_details_loading = false; //enabled loader
          });
    },

    //api to get portfolio data
    getRoiGraphData() {
      let url = "";

      if (this.active_sub_menu_link == "STOCKS") {
        url = "/overview/equity/stock/v1/market_cap_based_roi";
      } else {
        url = "/overview/equity/sector/v1/market_cap_based_roi";
      }

      return serverAddr
        .post(url, {
          user_id: Number(this.user_id),
          period: this.active_period,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);
            this.clearRoiGraphData(); //clear graph data e.g. xaxis, yaxis, series

            this.roi_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.reRenderRoiGraphInstance();

            this.is_roi_graph_data_available = false;
          }.bind(this)
        );
    },

    //api to get accuracy graph data
    getSuccessRateGraphData() {
      let url = "";

      if (this.active_sub_menu_link == "STOCKS") {
        url = "/overview/equity/stock/v1/market_cap_based_success_rate";
      } else {
        url = "/overview/equity/sector/v1/market_cap_based_success_rate";
      }

      return serverAddr
        .post(url, {
          user_id: Number(this.user_id),
          period: this.active_period,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);
            this.clearSuccessRateGraphData(); //clear graph data e.g. xaxis, yaxis, series

            this.success_rate_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.reRenderSuccessRateGraphInstance();

            this.is_success_rate_graph_data_available = false;
          }.bind(this)
        );
    },

    //api to get accuracy graph data
    getAccuracyGraphData() {
      let url = "";

      if (this.active_sub_menu_link == "STOCKS") {
        url = "/my_dashboard/v1/stock/market_cap_based_accuracy";
      } else {
        url = "/my_dashboard/v1/sector/market_cap_based_accuracy";
      }

      return serverAddr
        .post(url, {
          user_id: Number(this.user_id),
          period: this.active_period,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);
            this.clearAccuracyGraphData(); //clear graph data e.g. xaxis, yaxis, series

            this.accuracy_graph_instance.hideLoading(this.loader_default); //disabled loader

            this.reRenderAccuracyGraphInstance();

            this.is_accuracy_graph_data_available = false;
          }.bind(this)
        );
    },

    // api to get recommendation count data
    getRecommendationCount() {
      let url = "";

      if (this.active_sub_menu_link == "STOCKS") {
        url = "/my_dashboard/v1/stock/period_based_roi";
      } else {
        url = "/my_dashboard/v1/sector/period_based_roi";
      }

      return serverAddr
        .post(url, {
          user_id: Number(this.user_id),
          period: this.active_period,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);

            this.is_reco_count_data_available = false;

            this.reco_count_series[0].data = [];
          }.bind(this)
        );
    },

    async submitReview() {
      this.$v.$touch();

      if (this.review_title && this.review && this.checked) {
        this.is_review_submit_in_progress = true; //enabled button loader

        let params = {
          title: this.review_title,
          comment: this.review,
          response_type: "company", // Hardcoded response_type
          reviewed_user: 179, // Hardcoded user_id
        };

        serverAddr
          .post("/expert/v1/review/", params)
          .then(async (response) => {
            if (response.data.status) {
              new CripNotice({
                title: "Success",
                description: "Review submitted",
                type: "success",
                duration: 3,
              });

              this.is_review_section_loading = true; //enabled loader

              // after submitting reivew calleg get all reviews api to show updated review
              let review_res = await this.getAllReviews();

              if (review_res.data.status && review_res.data.data.length) {
                this.review_list = [];

                review_res.data.data.forEach((e) => {
                  let obj = {};
                  (obj.profile_pic = e.pic),
                    (obj.name =
                      e.created_by.first_name + " " + e.created_by.last_name),
                    (obj.designation = e.creator_profession),
                    (obj.rating = e.rating),
                    (obj.review_title = e.title),
                    (obj.review = e.comment),
                    (obj.date = e.review_date),
                    (obj.replied_users = e.replied_users);

                  this.review_list.push(obj);
                });

                this.total_review_pages =
                  review_res.data.pagination.total_pages;
                this.total_reviews = review_res.data.pagination.total_entries;
                this.review_current_page_no = 1;
              }
            }

            this.is_review_submit_in_progress = false; //disabled button loader

            this.is_review_section_loading = false; //disabled loader

            this.write_review_dialog_visibility = false; //closed review dialog
          })
          .catch(
            function(error) {
              console.log(error);
              this.is_review_submit_in_progress = false; //disabled button loader
              this.is_review_section_loading = false; //disabled loader
            }.bind(this)
          );
      }
    },

    // api to get all reviews
    getAllReviews() {
      const user_type = "company"; // Hardcoded response_type
      const user_id = 179; // Hardcoded response_id
      const reviewsPerPage = 2;

      return serverAddr
        .get(
          `/expert/v1/review/?reviewed_user=${user_id}&response_type=${user_type}&page_number=${
            this.review_current_page_no
          }&page_per_entries=${reviewsPerPage}`
        )
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },

    // api to get rating
    getUserRating() {
      return serverAddr
        .get(
          `/expert/v1/rating/?rating_user=${this.user_id}&response_type=${
            this.user_type
          }`
        )
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },

    sendVisitorsTrackToServer() {
      return serverAddr
        .post(`/expert/v1/visitors_track/`, {
          expert: this.user_id,
          response_type: this.user_type,
        })
        .then((response) => {
          return response;
        })
        .catch(
          function(error) {
            console.log(error);
          }.bind(this)
        );
    },

    // for protfolio chart
    highlightPortfolioChart(params, index, series_index) {
      this.roi_graph_instance.dispatchAction({
        type: "showTip",
        batch: [
          {
            seriesIndex: series_index,
            dataIndex: index,
          },
        ],
      });

      this.roi_graph_instance.dispatchAction({
        type: "highlight",
        seriesIndex: series_index,
        dataIndex: index,
      });
    },

    downPortfolioChart(params) {
      this.roi_graph_instance.dispatchAction({
        type: "hideTip",
      });

      this.roi_graph_instance.dispatchAction({
        type: "downplay",
        // seriesIndex: index,
      });
    },

    // for success rate chart
    highlightSuccessRateChart(params, index, series_index) {
      this.success_rate_graph_instance.dispatchAction({
        type: "showTip",
        batch: [
          {
            seriesIndex: series_index,
            dataIndex: index,
          },
        ],
      });

      this.success_rate_graph_instance.dispatchAction({
        type: "highlight",
        seriesIndex: series_index,
        dataIndex: index,
      });
    },

    downSuccessRateChart(params) {
      this.success_rate_graph_instance.dispatchAction({
        type: "hideTip",
      });

      this.success_rate_graph_instance.dispatchAction({
        type: "downplay",
        // seriesIndex: index,
      });
    },

    // for accuracy chart
    highlightAccuracyChart(params, index, series_index) {
      this.accuracy_graph_instance.dispatchAction({
        type: "showTip",
        batch: [
          {
            seriesIndex: series_index,
            dataIndex: index,
          },
        ],
      });

      this.accuracy_graph_instance.dispatchAction({
        type: "highlight",
        seriesIndex: series_index,
        dataIndex: index,
      });
    },

    downAccuracyChart(params) {
      this.accuracy_graph_instance.dispatchAction({
        type: "hideTip",
      });

      this.accuracy_graph_instance.dispatchAction({
        type: "downplay",
        // seriesIndex: index,
      });
    },

    // for reco count chart
    highlightRecoCountChart(params, index) {
      this.reco_count_graph_instance.dispatchAction({
        type: "showTip",
        batch: [
          {
            seriesIndex: 0,
            dataIndex: index,
          },
        ],
      });

      this.reco_count_graph_instance.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: index,
      });
    },

    downRecoCountChart(params) {
      this.reco_count_graph_instance.dispatchAction({
        type: "hideTip",
      });

      this.reco_count_graph_instance.dispatchAction({
        type: "downplay",
        // seriesIndex: index,
      });
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },

  computed: {
    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },

    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.StockAntsOverview {
  min-height: 100vh;
  background-color: $page-background-color;
  padding: 60px 0 30px 0px;

  // Below css for the background cover image for all screens
  .background-cover {
    position: relative;
    height: 300px;
    top: 0px;
    background-image: url("../assets/images/stockantsoverview/SA Cover photo (1).svg");
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  // css for profile card
  .profile-card {
    margin-top: -80px;
    background: #fff;
    box-shadow: 0px 2px 20px 0px rgba(115, 115, 115, 0.25);

    .subscribe-btn {
      padding: 12px 30px;
      width: 90%;
    }
    .profile-pic-section {
      img {
        width: 170px;
        bottom: 100px;
        position: absolute;
      }
    }
  }
  .active-button {
    background: #ea2526;
    color: white;
  }
  // .text-section {
  //   display: flex;
  //   flex-flow: row wrap;
  //   justify-content: flex-start;
  //   flex-wrap: wrap;
  // }

  .buttons-section {
    text-align: right;
  }
  .rank-wrapper {
    position: absolute;
    bottom: -12px;
    right: 0;
    left: 0;
  }

  .action-btns {
    text-align: right;
  }

  .rating-tag {
    background: #edeef4;
    border-radius: 6px;
    padding: 5px 12px;
    font-size: 0.7rem;
    font-weight: 500;
  }

  .performance-count {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    color: $secondary-theme-color;
    font-size: 0.8rem;
    font-weight: 600;
    border-radius: 8px;
    //     width: 180px;
    // height: 40px;
  }

  .title {
    font-size: 1rem;
    font-weight: 600;
    color: #545453;
  }

  .sub-title {
    font-size: 0.7rem;
    font-weight: 600;
    color: #000;
    // color: #545453;
  }

  .cover-page-container {
    box-sizing: border-box;

    .line-height-1-5 {
      line-height: 1.5;
    }
  }

  .review-section {
    .profile-pic {
      height: 38px;
      width: 38px;
      object-fit: cover;
      border-radius: 100%;
    }
  }

  .about-section {
    padding-bottom: 30px;
  }

  .stock-table {
    overflow-x: auto;
    border-spacing: 0;
    border-collapse: collapse;
    width: 100%;

    thead tr {
    }

    tbody tr td {
      font-size: 12px;
      font-weight: 500;
      text-align: center;
      padding: 15px 5px;
      height: 15px;
    }

    th {
      background-color: #ffff;
      border-bottom: 1px solid #e9e9e9;
      position: sticky;
      top: -2px;
      z-index: 1;
      color: #a5a6a8;
      font-weight: 600;
      font-size: 13px;
      padding: 5px;
    }

    tbody tr:hover {
      background-color: #eff5fe;
    }
    .stock-data {
      color: rgb(58, 58, 58);
    }
    .potential {
      color: rgb(86, 174, 104);
      font-weight: 600;
      text-align: center;
    }
  }

  .top-pick-container,
  .stock-table {
    transition: opacity 0.3s ease;
  }
  .top-pick-section {
    // padding: 5px;
    position: relative;
  }

  .top-pick-section.blur .stock-table {
    filter: blur(5px); /* You can adjust the blur amount as needed */
  }

  .lock-overlay {
    position: relative;
  }

  .card-container {
    max-height: 290px;
    overflow-y: auto; /* Add vertical scrollbar when content overflows */
    position: relative;
    margin: 0;
  }

  .card-container::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  .card-container::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  .card-container::-webkit-scrollbar-thumb {
    background: #c5c5c5;
  }

  /* Handle on hover */
  .card-container::-webkit-scrollbar-thumb:hover {
    background: #a9a9a9;
  }

  // Media query for Lock section
  .lock-section {
    text-align: center;
    color: red;
    font-weight: larger;
    margin-top: 80px;
  }

  // Media query for subscribe and youtube buttons
  .youtube-btn {
    display: block;
  }

  .u-tube-btn {
    display: none;
  }

  @media (max-width: 1358px) {
    .background-cover {
      height: 236px;
    }
  }
  @media (max-width: 1054px) {
    .background-cover {
      height: 185px;
    }
  }

  @media (max-width: 821px) {
    .background-cover {
      height: 150px;
    }
  }

  @media (max-width: 683px) {
    .background-cover {
      height: 120px;
    }
  }

  @media (max-width: 545px) {
    .background-cover {
      height: 206px;
      background-size: 100%;
      top: 0;
      background-image: url("../assets/images/phone.png");
    }
  }
  @media (max-width: 437px) {
    .background-cover {
      height: 175px;
    }
  }

  @media (max-width: 377px) {
    .background-cover {
      height: 150px;
    }
  }

  // Media query for box card text section
  @media screen and (max-width: 1283px) {
    .StockAntsOverview {
      padding: 50px 0 0 0;
    }
  }

  @media (max-width: 1000px) {
  }

  @media screen and (max-width: 992px) {
    .profile-card {
      margin-top: -40px;
    }
    .text-section {
      flex-wrap: wrap;
      margin-top: 35px;
      margin-bottom: 20px;
    }
    .profile-card .subscribe-btn {
      padding: 12px 30px;
      width: 100%;
    }
    .profile-card .profile-pic-section img {
      bottom: 210px;
      width: 140px;
    }

    .youtube-btn {
      display: none;
    }

    .u-tube-btn {
      display: flex;
    }
    .action-btns {
      text-align: left;
      margin-top: 40px;
    }

    .box-card {
      height: auto;
    }
  }

  @media screen and (min-width: 993px) {
    .fixed-height {
      min-height: 746px;
    }
  }
  @media screen and (max-width: 517px) {
    .text-section {
      #text {
        width: 80%;
      }
    }
    .profile-card .profile-pic-section img {
      bottom: 225px;
      width: 100px;
    }
  }

  // css for equity & options buttons
  .btns {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .custm-button {
    width: 140px;
    height: 35px;
    border-radius: 10px;
    margin-left: 10px;
  }

  /* Apply styles when the screen width is 380 pixels or below */
  @media screen and (max-width: 380px) {
    .custm-button {
      margin-left: 0;
      margin-top: 10px;
    }
  }
}
</style>

<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.StockAntsOverview {
  .profile-card {
    overflow: visible;
    box-shadow: none;
    border-radius: 10px;
  }

  .about-us-card {
    border-radius: 10px;
  }

  .el-progress__text {
    font-size: 0.6rem !important;
    color: $primary-theme-color !important;
    font-weight: 500;
  }

  .el-dialog {
    border-radius: 10px;
  }

  .el-dialog__title {
    font-size: 1rem;
    font-weight: 600;
    color: #000;
  }

  .access-code-dialog {
    .el-dialog {
      width: 30%;
    }

    .el-dialog__body {
      padding: 10px 10px 20px 10px;
    }
  }

  .custom-dialog {
    width: 35% !important;
    // padding: 10px 10px 20px 10px;
    border-radius: 10px !important;
    overflow: hidden;
  }
  .dialog-title {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    color: #2d2e8d;
    margin: 0;
  }

  /* Section Styles */
  .section {
    margin-bottom: 20px;
  }

  /* Section Header */
  .section-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .icon {
    height: 10px;
    width: 10px;
    margin-right: 10px;
  }

  .section-title {
    font-size: 13px;
    font-weight: 700;
    margin: 0;
    color: #000000;
  }

  /* Section Content */
  .section-content {
    padding-left: 20px;
    font-size: 13px;
    font-weight: 500;
    list-style: disc;
    color: #3c3c3c;
  }
  @media screen and (max-width: 992px) {
    .access-code-dialog {
      .el-dialog {
        width: 45%;
      }
    }
    .custom-dialog {
      width: 45% !important;
    }
  }

  @media screen and (max-width: 650px) {
    .access-code-dialog {
      .el-dialog {
        width: 80%;
      }
    }
    .custom-dialog {
      width: 90% !important;
    }
  }

  .review-section {
    .review-card {
      border-radius: 10px;

      .el-card__body {
        padding: 5px 20px;
      }
    }

    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  //  Mediaquery for subscribe button of Today's top picks section
  @media (max-width: 991px) {
    #subscribe-button {
      display: block;
      //width: 400px;
    }
  }

  @media (min-width: 992px) {
    #subscribe-button {
      display: none;
    }
  }

  .access-code-input {
    width: 200px;

    .el-input__inner {
      border-radius: 50px;
    }
  }

  .el-carousel__container {
    min-height: 450px;
  }

  .el-carousel__item.is-active {
    z-index: 0;
  }
}
.el-popover__title {
  color: #ffff;
  margin-bottom: 0;
}

.el-popover {
  min-width: 100px !important;
  background-color: #000000d3;
  border: 1px solid;
  padding: 10px 15px;
}

.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  border-style: unset;
}
</style>
